export type OrderFormFields = {
	[key: string]: {
		name: string;
		legend: string;
		options?: readonly {
			value: string;
			label: string;
			description?: string;
			price?: number;
			openingHours?: readonly string[];
		}[];
	};
};

export const orderFormFields = {
	cake: {
		name: 'cake',
		legend: 'Kake',
		options: [
			{
				value: 'small',
				label: 'Liten',
				description: 'ca 10 biter (Tekst og bilde ikke mulig)',
			},
			{
				value: 'medium',
				label: 'Medium',
				description: 'ca 16 biter',
			},
			{
				value: 'large',
				label: 'Stor',
				description: 'ca 24 biter',
			},
			{
				value: 'xlarge',
				label: 'Halvpanne',
				description: 'ca 35 biter',
			},
			{
				value: 'xxlarge',
				label: '3/4 Panne',
				description: 'ca 50 biter',
			},
			{
				value: 'xxxlarge',
				label: 'Helpanne',
				description: 'ca 70 biter',
			},
		],
	},
	fill: {
		name: 'fill',
		legend: 'Fyll',
		options: [
			{value: 'raspberry', label: 'Bringebær'},
			{value: 'vanilla', label: 'Vanilje'},
			{value: 'strawberry', label: 'Jordbær'},
			{value: 'walnuts', label: 'Valnøtter'},
			{value: 'apricot', label: 'Aprikos'},
			{value: 'krokant', label: 'Krokan'},
			{value: 'blackberry', label: 'Bjørnebær'},
		],
	},
	top: {
		name: 'top',
		legend: 'Topp',
		options: [
			{value: 'marzipan', label: 'Marsipan'},
			{value: 'cream', label: 'Krem m/krokankant'},
			{value: 'chocolate', label: 'Sjokolade'},
		],
	},
	bottom: {
		name: 'bottom',
		legend: 'Kakebunn',
		options: [
			{value: 'sugarbread', label: 'Sukkerbrød'},
			{value: 'chocolate', label: 'Sjokoladebunn'},
		],
	},
	occasion: {
		name: 'occasion',
		legend: 'Anledning',
	},
	text: {
		name: 'text',
		legend: 'Tekst',
	},
	otherCakes: {
		name: 'otherCakes',
		legend: 'Andre kaker',
		options: [
			{
				value: 'kransekake',
				label: 'Kransekake',
				description: '18 ringer',
			},
			{
				value: 'ostekakePasjonsfrukt',
				label: 'Ostekake med pasjonsfrukt',
				description: '16 biter',
			},
			{
				value: 'ostekakeJordbaer',
				label: 'Ostekake med jordbær',
				description: '16 biter',
			},
			{
				value: 'successterte',
				label: 'Successterte',
				description: 'ca 16 biter',
			},
			{
				value: 'verdensbesteSmall',
				label: 'Verdens beste',
				description: 'ca 16 biter',
			},
			{
				value: 'verdensbesteLarge',
				label: 'Verdens beste',
				description: 'ca 35 biter',
			},
			{
				value: 'hvetekringle',
				label: 'Hvetekringle',
				description: 'ca 25 biter',
			},
			{
				value: 'wienerkringle',
				label: 'Wienerkringle',
				description: 'ca 25 biter',
			},
			{
				value: 'waleskringleVanilla',
				label: 'Waleskringle',
				description: 'ca 25 biter m/vaniljefyll',
			},
			{
				value: 'waleskringlePlum',
				label: 'Waleskringle',
				description: 'ca 25 biter m/svisker i fyll',
			},
		],
	},
	delivery: {
		name: 'delivery',
		legend: 'Utleveringssted',
		options: [
			{
				value: 'dokka',
				label: 'Dokka',
				description: 'Skysstasjonen (R 15)',
				openingHours: ['Man-Tor: 08:30-17:00', 'Fre: 08:30-18:00', 'Lør: 08:30-15:00'],
			},
			{
				value: 'gjovik-cc',
				label: 'Gjøvik',
				description: 'CC Mat Gjøvik (R 7)',
				openingHours: ['Man-Fre: 09:00-21:00', 'Lør: 09:00-19:00'],
			},
			{
				value: 'gjovik-kaspergarden',
				label: 'Gjøvik',
				description: 'Kaspergården (R 7)',
				openingHours: ['Man-Fre: 07:00-17:00', 'Lør: 09:00-16:00'],
			},
			{
				value: 'hamar',
				label: 'Hamar',
				description: 'CC Mat Hamar Stadion (R 6)',
				openingHours: ['Man-Fre: 09:00-21:00', 'Lør: 09:00-19:00'],
			},
			{
				value: 'lena',
				label: 'Lena',
				description: 'Rådhustorget (R 19)',
				openingHours: ['Man-Fre: 09:00-16:00', 'Lør: 09:00-15:00'],
			},
			{
				value: 'lillehammer-kremerhuset',
				label: 'Lillehammer',
				description: 'Kremerhuset (R 7)',
				openingHours: ['Man-Fre: 09:00-20:00', 'Lør: 09:00-18:00'],
			},
			{
				value: 'lillehammer-cc',
				label: 'Lillehammer',
				description: 'CC Mat LHMR (R 7)',
				openingHours: ['Man-Fre: 09:00-21:00', 'Lør: 09:00-19:00'],
			},
			{
				value: 'kjelstad-bakeri-&-kafe-raufoss-amfi',
				label: 'Kjelstad Bakeri & Kafé',
				description: 'Raufoss AMFI  (R 18)',
				openingHours: ['Man-Fre: 08:00-20:00', 'Lør: 08:00-18:00'],
			},
		],
	},
	deliveryCC: {
		name: 'delivery',
		legend: 'Utleveringssted',
		options: [
			{value: 'gjovik', label: 'Gjøvik', description: 'CC Mat'},
			{value: 'hamar', label: 'Hamar', description: 'CC Mat'},
			{value: 'lillehammer', label: 'Lillehammer', description: 'CC Mat'},
		],
	},
	name: {
		name: 'name',
		legend: 'Fornavn og etternavn',
	},
	phone: {
		name: 'phone',
		legend: 'Telefonnummer',
	},
	email: {
		name: 'email',
		legend: 'E-post',
	},
	address: {
		name: 'address',
		legend: 'Adresse',
	},
	deliveryDate: {
		name: 'deliveryDate',
		legend: 'Leveringsdato',
	},
} as const satisfies OrderFormFields;
